const { newGuid } = require('../../utils');
var DomainException = require('../DomainException');
const AggregateRoot = require('../ddd/AggregateRoot');
const _ = require('../../lodash');

class Form extends AggregateRoot {
   constructor({ user, logger, sequenceProvider }) {
      super({ user, logger });

      this.sequenceProvider = sequenceProvider;
   }

   get agt() {
      return 'Form';
   }

   async initNew({ name, description, idFormType, enabled, scoringEnabled, scoreVisible, noForm = null }) {
      const tid = this.domainUser.tid;

      let noFormNew = noForm ? noForm : this.sequenceProvider ? await this.sequenceProvider.getNextFormNo({ tid }) : -1;

      let p = {
         aid: newGuid(),
         noForm: noFormNew,
         name,
         description,
         idFormType,
         tid,
         enabled,
         deleted: false,
         scoring: {
            enabled: scoringEnabled,
            scoreVisible: scoreVisible
         },
         items: [],
         order: [],
         idFieldMax: 0
      };

      this.apply('FORM_ADDED', p);

      var o = _.omit(p, ['aid', 'tid']);

      this.setData(
         {
            properties: _.merge(
               {
                  id: p.aid
               },
               o
            )
         },
         true
      );
   }

   updateScoring({ scoringEnabled, scoreVisible }) {
      const before = _.pick(this._properties.scoring, ['enabled', 'scoreVisible']);

      var p = {
         after: { enabled: scoringEnabled, scoreVisible },
         before,
         noForm: this._properties.noForm
      };

      this.apply('FORM_SCORING_UPDATED', p);

      this._properties.scoring = {
         enabled: p.after.enabled,
         scoreVisible: p.after.scoreVisible
      };
   }

   updateProperties({ name, description }) {
      if (!name) {
         throw new DomainException('A form needs a name.');
      }

      const before = _.pick(this._properties, ['name', 'description']);

      var p = { after: { name, description }, before, noForm: this._properties.noForm };

      this.apply('FORM_PROPS_UPDATED', p);

      this._properties.name = p.after.name;
      this._properties.description = p.after.description;
   }

   updateFields({ order = null, items }) {
      let newOrder = order;

      if (!order) {
         newOrder = [];
         for (var i = 0; i < items.length; i++) {
            newOrder.push(items[i].id);
         }
      }

      const before = _.pick(this._properties, ['order', 'items', 'idFieldMax']);

      let givenItems = items || [];

      var uniqueItems = _.uniqBy(givenItems, (x) => {
         return x.id;
      });

      if (uniqueItems.length != givenItems.length) {
         throw new DomainException('All given item ids must be unique.');
      }

      var idFieldMax = this.calculateIdFieldMax(items);

      var p = { after: { order: newOrder, items, idFieldMax }, before, noForm: this._properties.noForm };

      this.apply('FORM_FIELDS_UPDATED', p);

      this.updateIdFieldMaxToValue(idFieldMax);

      this._properties.order = p.after.order;
      this._properties.items = p.after.items;
   }

   delete() {
      var p = { deleted: true };
      p.noForm = this._properties.noForm;

      this.apply('FORM_DELETED', p);

      this._properties.deleted = true;
   }

   getFormNo() {
      return this._properties.noForm;
   }

   getFormItem({ idFormItem }) {
      return this.guardMissingItem(idFormItem);
   }

   getChildItems({ idFormItem }) {
      if (!idFormItem) {
         throw new Error('idFormItem is null');
      }
      let foundItems = [];
      var children = _.filter(this._properties.items, (l) => {
         return l.idParent == idFormItem;
      });

      _.each(children, (n) => {
         foundItems.push(n);
         foundItems = foundItems.concat(this.getChildItems({ idFormItem: n.id }));
      });
      return foundItems;
   }

   /* =================== */

   guardMissingItem(idFormItem, message) {
      message = message || 'No such form item exists.';
      var i = _.find(this._properties.items, { id: idFormItem });
      if (!i) {
         throw new DomainException(message);
      }
      return i;
   }

   getNextFormItem() {
      let idNext = this._properties.idFieldMax + 1;
      return idNext;
   }

   calculateIdFieldMax(items) {
      let idMax = 0;
      if (items.length > 0) {
         var sorted = _.sortBy(items, (ag) => {
            return ag.id;
         });

         idMax = sorted.reverse()[0].id;
      }

      return idMax;
   }

   updateIdFieldMax() {
      let idMax = this.calculateIdFieldMax(this._properties.items);
      this.updateIdFieldMaxToValue(idMax);
   }

   updateIdFieldMaxToValue(idMax) {
      this._properties.idFieldMax = this._properties.idFieldMax > idMax ? this._properties.idFieldMax : idMax;
   }
}

module.exports = Form;
